import { render, staticRenderFns } from "./InventoryCard.vue?vue&type=template&id=405dad78&scoped=true&"
import script from "./InventoryCard.vue?vue&type=script&lang=js&"
export * from "./InventoryCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCard.vue?vue&type=style&index=0&id=405dad78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405dad78",
  null
  
)

export default component.exports